export interface EditDictionarieState {
  documentVehicle: {
    documents: Array<DocumentType>
    document: {
      id?: number | string
      typeDocument: { value: string | number; label: string }
      OSAGO_DOCUMENT?: {
        value: string | number
        label: string
        files?: Array<{ link: string }>
      }
      REG_DOCUMENT?: { value: string | number; label: string }
      PTS_DOCUMENT?: { value: string | number; label: string }
      DSAGO_DOCUMENT?: { value: string | number; label: string }
      CASKO_DOCUMENT?: { value: string | number; label: string }
      DIAG_CARD?: { value: string | number; label: string }
    }
  }
  documentOrgVehicle: {
    orders: []
    order: DocumentType
  }
}
export interface DocumentType {
  [key: string]: string | number
}

export enum DICTIONARIE_VEHICLE_DOCUMENT_TYPE {
  PTS_DOCUMENT = 'PTS_DOCUMENT',
  REG_DOCUMENT = 'REG_DOCUMENT',
  OSAGO_DOCUMENT = 'OSAGO_DOCUMENT',
  DSAGO_DOCUMENT = 'DSAGO_DOCUMENT',
  CASKO_DOCUMENT = 'CASKO_DOCUMENT',
  DIAG_CARD = 'DIAG_CARD',
  PTO_DOCUMENT = 'PTO_DOCUMENT',
  PASS_DOCUMENT = 'PASS_DOCUMENT',
}
